var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "images" },
    [
      _c(
        "swiper",
        {
          ref: "currentImage",
          class: _vm.getClassName("current-image"),
          attrs: { options: _vm.swiperOptions }
        },
        _vm._l(_vm.images, function(img) {
          return _c(
            "swiper-slide",
            { key: img.id, staticClass: "current-image__item" },
            [
              _c("v-img", {
                attrs: {
                  src: img.src,
                  alt: img.alt,
                  "max-width": "100%",
                  height: _vm.media ? "62.5vw" : "639px"
                }
              }),
              _vm._v(" "),
              img.caption
                ? _c(
                    "div",
                    { class: _vm.getClassName("current-image__caption") },
                    [_vm._v(_vm._s(img.caption))]
                  )
                : _vm._e()
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.media
        ? _c(
            "div",
            { staticClass: "thumbnails--sp" },
            [
              _c(
                "swiper",
                { ref: "thumbnails", attrs: { options: _vm.thumbsOptions } },
                _vm._l(_vm.images, function(img, index) {
                  return _c(
                    "swiper-slide",
                    { key: img.id, staticClass: "thumbnails__item--sp" },
                    [
                      _c("v-img", {
                        class: _vm.getClassNameThumbs(
                          "thumbnails__action",
                          index
                        ),
                        attrs: {
                          src: img.src,
                          alt: img.alt,
                          width: "46",
                          height: "46"
                        },
                        on: {
                          click: function($event) {
                            return _vm.changeImage(index)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "thumbnails__button--prev",
                attrs: { slot: "button-prev" },
                slot: "button-prev"
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "thumbnails__button--next",
                attrs: { slot: "button-next" },
                slot: "button-next"
              })
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "thumbnails" },
            _vm._l(_vm.images, function(img, index) {
              return _c(
                "div",
                { key: img.id },
                [
                  _c("v-img", {
                    class: _vm.getClassNameThumbs("thumbnails__action", index),
                    attrs: {
                      src: img.src,
                      alt: img.alt,
                      width: "84",
                      height: "84"
                    },
                    on: {
                      click: function($event) {
                        return _vm.changeImage(index)
                      }
                    }
                  })
                ],
                1
              )
            }),
            0
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }